const RATE_OPTIONS = ["Copy Public Link (Rate Visible)", "Copy Public Link (Rate Hide)"];
const DRIVER_NOTIFICATION_OPTIONS = ["Send Driver Itinerary", "Send Broker Update", "Send BOL Notification"];
const TRIP_NOTIFICATION_OPTIONS = ["Send Driver Itinerary", "Send Broker Update"];

export { RATE_OPTIONS, DRIVER_NOTIFICATION_OPTIONS, TRIP_NOTIFICATION_OPTIONS };
